import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/global-components/logo/Logo-trust.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/languages/language/blocks/Language-documents-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/languages/language/blocks/Language-hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/languages/language/blocks/Language-process-work.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/languages/language/blocks/Language-translation-prising.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/languages/language/blocks/Language-use-case.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/languages/language/blocks/Languages-industry.tsx");
